export function userinfo(params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/user/v1/userinfo',
    params
  });
}
// export function accredit(params) {
//   return this.fetch({
//     method: 'GET',
//     url: 'wx-server/weixin/login/v1/exchange/wxtoken',
//     params
//   });
// }
export function getToken(params) {
  return this.fetch({
    method: 'GET',
    url: 'mall/v1/store/info',
    params
  });
}
export function getLoginType(params) {
  return this.fetch({
    method: 'GET',
    url: 'mall/get/login_type',
    params
  });
}
export function getLoginURL(params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/oauth/login/v1/getCCLoginUrl',
    params
  });
}
